import {
  RequestableState,
  createRequestableState,
  handleDone,
  handleFailed,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { dashboard } from 'types';
import { payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

type State = RequestableState<dashboard.BusinessClosedDay[]>;

const initialState: State = createRequestableState<dashboard.BusinessClosedDay[]>();

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type } = action;

  switch (type) {
    case AppConstants.BUSINESS_CLOSED_DAYS_FETCH_STARTING:
    case AppConstants.BUSINESS_CLOSED_DAYS_ADD_STARTING:
    case AppConstants.BUSINESS_CLOSED_DAYS_DELETE_STARTING: {
      return handleStarting(state, action);
    }

    case AppConstants.BUSINESS_CLOSED_DAYS_FETCH_DONE: {
      return handleDone(state, action);
    }

    case AppConstants.BUSINESS_CLOSED_DAYS_FETCH_FAILED: {
      return handleFailed(state, action);
    }

    case AppConstants.BUSINESS_CLOSED_DAYS_ADD_FAILED:
    case AppConstants.BUSINESS_CLOSED_DAYS_DELETE_FAILED: {
      return {
        ...state,
        isRequesting: false,
      };
    }

    case AppConstants.BUSINESS_CLOSED_DAYS_ADD_DONE: {
      return {
        ...state,
        isRequesting: false,
        data: state.data
          ? [...state.data, payloadToJSON(action.payload)]
          : [payloadToJSON(action.payload)],
      };
    }

    case AppConstants.BUSINESS_CLOSED_DAYS_DELETE_DONE: {
      const { context } = action;

      if (!action.payload || !state.data) {
        return { ...state, isRequesting: false };
      }

      return {
        ...state,
        isRequesting: false,
        data: state.data.filter((day) => day.id !== context.id),
      };
    }

    default:
      return state;
  }
}
